import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { WebAssetsContext } from "../../App";
import Exchangesalesperson from "./Exchangesalesperson";
import { ToastContainer } from "react-toastify";
import { Tooltip } from "react-tooltip";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import {
  loggedInUserDetails,
  alertDanger,
  currencySymbol,
  changeDateFotmate,
  apibaseURl,
  errorToast,
  successToast,
  getvalidationErr,
} from "../../functions/Function";

const Order = (props) => {
  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const navigate = useNavigate();
  const [salesPerson, setSalesPersons] = useState([]);
  const [show, setShow] = useState(false);
  const [currentsalesperson, setcurrentsalesperson] = useState("");
  const [currentOrderId, setcurrentOrderId] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

const fetchData = async () => {
  try {
    const response = await fetch(`${apibaseURl}getOrders`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    if (result.status === true) {
      console.log("result", result);
      setData(result.response);
    } else {
      console.warn("API returned false status", result);
    }
  } catch (error) {
    console.error("Error fetching orders:", error);
  }
};

  const fetchSalesPersons = () => {
    fetch(apibaseURl + "getstaffs")
      .then((res) => res.json())
      .then((result) => {
        if (result.status === true) {
          setSalesPersons(result.response);
        }
      });
  };

  const handleClickOnStatus = (orderid = "") => {
    Swal.fire({
      title: "Are you sure you want to change order status?",
      text: "Once changed, you will not be able to revert it!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteStatus(orderid);
      }
    });
  };

  const deleteStatus = async (orderid = "") => {
    let res = await fetch(apibaseURl + "updateOrderStatus", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: orderid }),
    });

    let output = await res.json();
    if (res.status === 200 && output.status === true) {
      successToast(output.response, "top-right", "6000");
      fetchData();
    }
  };

  const HandleClickOnDeleteOrder = async (id = "") => {
    setLoading(true);
    Swal.fire({
      title: "Are you sure you want to delete it?",
      text: "Once deleted, you will not be able to recover it!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const output = await Deleteorder(id);
          if (output.status === true) {
            Swal.fire({
              title: "Deleted!",
              text: "Order deleted successfully.",
              icon: "success",
            }).then(() => {
              setLoading(false);
              fetchData();
            });
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        setLoading(false);
      }
    });
  };

  const Deleteorder = async (id = "") => {
    const res = await fetch(apibaseURl + "deleteOrder", {
      method: "POST",
      body: JSON.stringify({ id: id }),
    });
    let resJson = await res.json();
    return resJson;
  };

  const handleClose = () => setShow(false);
  const handleShow = (row) => {
    setShow(true);
    setcurrentsalesperson(row.user_id);
    setcurrentOrderId(row.id);
  };

  useEffect(() => {
    if (loggedInUserDetails("role") === "administrator") {
      fetchData();
      fetchSalesPersons();
    }
  }, []);

  const grandTotal = (amount = 0, discount = 0) => {
    const totalAmount = Number(amount);
    const totalDiscount = Number(discount);
    return (totalAmount - totalDiscount).toFixed(2);
  };

  const columns = [
    {
      name: "S.NO",
      selector: (row, index) => index + 1,
      width: "70px",
    },
    {
      name: "Order ID",
      selector: (row) => `#${row.id}`,
      sortable: true,
      width: "100px",
    },
    // {
    //   name: "Staff ID",
    //   selector: (row) => `#${row.user_id}`,
    // },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-icon btn-primary"
            onClick={() => navigate("/admin/orders/order/" + row.id)}
          >
            <i className="far fa-eye"></i>
          </button>

          <button
            className="btn btn-icon btn-info"
            onClick={() => handleShow(row)}
          >
            <i className="fa-solid fa-arrow-right-arrow-left"></i>
          </button>

          <button
            className="btn btn-icon btn-danger"
            onClick={() => HandleClickOnDeleteOrder(row.id)}
          >
            <i className="far fa-trash-alt"></i>
          </button>
        </div>
      ),
    },
    {
      name: "Staff Name",
      selector: (row) => row.staff_name,
      sortable: true,
    },
    {
      name: "Company Name",
      selector: (row) => row.company_name,
      sortable: true,
    },
    // {
    //   name: "Buyer Name",
    //   selector: (row) => row.buyer_name,
    // },
    // {
    //   name: "Buyer Email",
    //   selector: (row) => row.buyer_email,
    // },
    // {
    //   name: "Buyer Phone",
    //   selector: (row) => row.buyer_phone,
    // },
    {
      name: "Delivery Date",
      selector: (row) =>
        row.delivery_date !== "0000-00-00"
          ? changeDateFotmate(row.delivery_date, "DD-MM-YYYY")
          : "",
    },
    {
      name: "Amount",
      selector: (row) => `${currencySymbol}${row.amount}`,
    },
    // {
    //   name: "Discount",
    //   selector: (row) =>
    //     `${currencySymbol}${row.discount} (${row.discount_percentage}%)`,
    // },
    {
      name: "Total Amount",
      selector: (row) => `${currencySymbol}${grandTotal(row.amount, row.discount)}`,
    },
    {
      name: "Status",
      cell: (row) => (
        <button
          type="button"
          onClick={() => handleClickOnStatus(row.id)}
          className={`badge ${row.status === "Completed" ? "badge-success" : "badge-danger"}`}
        >
          {row.status}
        </button>
      ),
    },

  ];

  return (
    <>
      {!loading && (
        <>
          <Exchangesalesperson
            show={show}
            handleClose={handleClose}
            salesPerson={salesPerson}
            currentsalesperson={currentsalesperson}
            currentOrderId={currentOrderId}
          />
          <ToastContainer />
          <div className="section-body">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="headercolor mb-4">Orders List</h4>
                    <DataTable
                      columns={columns}
                      data={data}
                      pagination
                      paginationPosition="top" // Show pagination on top
                      paginationPerPage={50} // Show 50 rows by default
                      paginationRowsPerPageOptions={[10, 20, 50, 100]} // Pagination options
                      highlightOnHover
                      striped
                      className="react-dataTable"
         
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Order;
